module.exports = __webpack_public_path__ + "img/photo_2.69709110.jpg";